"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandsQueue = void 0;
const commands_1 = require("./commands");
const utils_1 = require("./utils");
class CommandsQueue {
    constructor(callInfoFactory, timer, uuidFactory) {
        this.callInfoFactory = callInfoFactory;
        this.timer = timer;
        this.uuidFactory = uuidFactory;
        this.queue = [];
        this.storageDeferred = (0, utils_1.createDeferred)();
    }
    init(storage) {
        this.storageDeferred.resolve(storage);
        this.queue.forEach(cmd => {
            this.handleCommand(cmd);
        });
    }
    handleCommand(cmd) {
        if (!this.storageDeferred.isResolved) {
            return;
        }
        switch (cmd.type) {
            case commands_1.CommandType.AddIssue:
                this.storageDeferred.value.addIssue(cmd);
                break;
            case commands_1.CommandType.AddLogEntry:
                this.storageDeferred.value.addLogEntry(cmd);
                break;
            case commands_1.CommandType.AddLogMessage:
                this.storageDeferred.value.addLogMessage(cmd);
                break;
            case commands_1.CommandType.ForceSendOnce:
                this.storageDeferred.value.forceSendOnce();
                break;
            case commands_1.CommandType.SetDeviceKey:
                this.storageDeferred.value.addDeviceKey(cmd);
                break;
            default:
                throw new utils_1.UnreachableCaseError(cmd);
        }
    }
    add(cmd) {
        if (this.storageDeferred.isFulfilled) {
            this.handleCommand(cmd);
        }
        else {
            this.queue.push(cmd);
        }
    }
    addIssue(issueType, title, text) {
        const url = (0, utils_1.createDeferred)();
        this.add({
            type: commands_1.CommandType.AddIssue,
            issueType,
            title,
            text,
            uuid: this.uuidFactory.create(),
            callInfo: this.callInfoFactory.create(),
            url,
            time: this.timer.getTime(),
        });
        return url.promise;
    }
    addLogEntry(log) {
        this.add({
            type: commands_1.CommandType.AddLogEntry,
            log,
            callInfo: this.callInfoFactory.create(),
            time: this.timer.getTime(),
        });
    }
    addLogMessage(level, parameters) {
        this.add({
            type: commands_1.CommandType.AddLogMessage,
            level,
            parameters,
            callInfo: this.callInfoFactory.create(),
            time: this.timer.getTime(),
        });
    }
    forceSendOnce() {
        this.add({
            type: commands_1.CommandType.ForceSendOnce
        });
    }
    setDeviceKey(key, value) {
        this.add({
            type: commands_1.CommandType.SetDeviceKey,
            key,
            value,
            callInfo: this.callInfoFactory.create(),
            time: this.timer.getTime(),
        });
    }
}
exports.CommandsQueue = CommandsQueue;
